import React from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME } from '../reducer';
import { I18n } from 'react-redux-i18n';
import PopupWarning from './../../../common/popup-portal/popup-warning/PopupWarning';

class PopupWarningNoTicker extends React.Component {
  render() {
    const {
      parentRef,
      currentTab,
      listTickerAllScore,
      isLoading,
      currentItemSearch,
    } = this.props;
    let isShowPopup = false;

    if (!isLoading) {
      if (
        currentTab === 2 &&
        !listTickerAllScore.length &&
        Object.keys(currentItemSearch).length
      ) {
        isShowPopup = true;
      }
    }

    if (!isShowPopup) return null;
    return (
      <PopupWarning
        text={I18n.t('stRanking.popup.warning.title')}
        isShow={isShowPopup}
        onOverlayClicked={true}
        textContent={I18n.t('stRanking.popup.warning.content')}
        parentRef={parentRef ? parentRef.current : null}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    currentItemSearch: state[REDUCER_NAME].currentItemSearch,
    listTickerAllScore: state[REDUCER_NAME].listTickerAllScore,
    listTickerRanking: state[REDUCER_NAME].listTickerRanking,
    currentTab: state[REDUCER_NAME].currentTab,
    isLoading: state[REDUCER_NAME].isLoading,
  };
};

export default connect(mapStateToProps)(PopupWarningNoTicker);
